import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { RememberService } from '../../../core/services/remember.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-consignment-plans-delivery-labour',
  templateUrl: './consignment-plans-delivery-labour.component.html',
  styleUrls: ['./consignment-plans-delivery-labour.component.css']
})
export class ConsignmentPlansDeliveryLabourComponent implements OnInit {
    public searchText: string = '';

    public itemsListLabours: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService, private rememberService: RememberService) {

    }

    private async loadLabours() {
        this.itemsListLabours = await this.datatask.Post(1790);
    }

    public async goBackToPrevious(event: { item: Item; event: MouseEvent }) {
        Promise.all([
            this.rememberService.remember('consignmentplansdelivery.labour_no', event?.item?.item_id),
            this.rememberService.remember('consignmentplansdelivery.labour_name', event?.item?.item_name)
        ]).then(() => {
            this.stateService.back();
            Promise.resolve();
        });
    }

    private async init() {
        this.loadLabours();
    }

    ngOnInit() {
        this.init();
    }
}
